import en from './en-US';
import pt from './pt-BR';
import ptPT from './pt-PT';

const i18nMessages = {
  ...en,
  ...pt,
  ...ptPT,
};

export default i18nMessages;
